import { render, staticRenderFns } from "./scorerecordlist.vue?vue&type=template&id=dce7d548"
import script from "./scorerecordlist.vue?vue&type=script&lang=js"
export * from "./scorerecordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports